// extracted by mini-css-extract-plugin
export var active = "_ex-2";
export var recordingDot = "_ex-1";
export var recordingIndicator = "_ex-0";